import { __assign } from "tslib";
import * as moment from 'moment-timezone';
import * as utils from '../components/containers/Calendar/CalendarUtlis/CalendarUtils';
import MomentEnum from '../enums/MomentEnum';
export function getMonthBeforFillers(_a) {
    var dateObject = _a.dateObject, mutableDates = _a.mutableDates, weekStarter = _a.weekStarter;
    var fillerDays = utils.getMonthFirstWeekDay(dateObject, weekStarter);
    var dateLimit = moment(dateObject).startOf(MomentEnum.monthString);
    var dateIndex = moment(dateLimit).subtract(fillerDays, MomentEnum.days);
    return utils.getDatesWithEvents({
        dateIndex: dateIndex,
        dateLimit: dateLimit,
        mutableDates: mutableDates,
        weekStarter: weekStarter,
    });
}
export function getAfterMonthFillers(_a) {
    var dateObject = _a.dateObject, mutableDates = _a.mutableDates, weekStarter = _a.weekStarter;
    var first = utils.getNextMonthFirstWeekDay(dateObject, weekStarter);
    var fillersAmount = 7 - first;
    var dateIndex = utils.getNextMonthFirstDate(dateObject);
    var dateLimit = moment(dateIndex).add(fillersAmount, MomentEnum.days);
    return utils.getDatesWithEvents({
        dateIndex: dateIndex,
        dateLimit: dateLimit,
        mutableDates: mutableDates,
        weekStarter: weekStarter,
    });
}
export default function getCalendar(_a) {
    var dateObject = _a.dateObject, dates = _a.dates, weekStarter = _a.weekStarter;
    var mutableDates = __assign({}, dates);
    var getDaysByGetter = function (getter) {
        return getter({ dateObject: dateObject, mutableDates: mutableDates, weekStarter: weekStarter });
    };
    var beforeFillers = getDaysByGetter(getMonthBeforFillers).datesToReturn;
    var _b = getDaysByGetter(utils.getMonthDaysWithEvents), days = _b.datesToReturn, eventsAmount = _b.eventsAmount;
    var getAfterMonthFillersDays = getDaysByGetter(getAfterMonthFillers).datesToReturn;
    var afterFillers = utils.hasAfterFillers(beforeFillers, days)
        ? getAfterMonthFillersDays
        : {};
    return {
        days: days,
        beforeFillers: beforeFillers,
        afterFillers: afterFillers,
        isNoEventsThisMonth: !eventsAmount,
    };
}
//# sourceMappingURL=getMonthFillers.js.map